import permissions from './permission-list'

export default [
  {
    path: '/payment-methods',
    name: 'payment-methods',
    component: () => import('@/views/PaymentMethods.vue'),
    meta: {
      pageTitle: 'Metode Pembayaran',
      resource: permissions.paymentMethod,
      action: 'read',
      navActiveLink: 'payment-methods',
      breadcrumb: [
        { text: 'Metode Pembayaran', active: true },
      ],
    },
  },
  {
    path: '/payment-methods/create',
    name: 'payment-methods-create',
    component: () => import('@/views/PaymentMethodCreate.vue'),
    meta: {
      pageTitle: 'Buat Metode Pembayaran',
      resource: permissions.paymentMethod,
      action: 'manage',
      navActiveLink: 'payment-methods',
      breadcrumb: [
        { text: 'Metode Pembayaran', to: { name: 'payment-methods' } },
        { text: 'Buat', active: true },
      ],
    },
  },
  {
    path: '/payment-methods/:id/detail',
    name: 'payment-methods-detail',
    component: () => import('@/views/PaymentMethodDetail.vue'),
    meta: {
      pageTitle: 'Detail Metode Pembayaran',
      resource: permissions.paymentMethod,
      action: 'read',
      navActiveLink: 'payment-methods',
      breadcrumb: [
        { text: 'Metode Pembayaran', to: { name: 'payment-methods' } },
        { text: 'Detail', active: true },
      ],
    },
  },
  {
    path: '/payment-methods/:id/edit',
    name: 'payment-methods-edit',
    component: () => import('@/views/PaymentMethodEdit.vue'),
    meta: {
      pageTitle: 'Edit Metode Pembayaran',
      resource: permissions.paymentMethod,
      action: 'manage',
      navActiveLink: 'payment-methods',
      breadcrumb: [
        { text: 'Metode Pembayaran', to: { name: 'payment-methods' } },
        { text: 'Edit', active: true },
      ],
    },
  },
]
